import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { ROLES_FEATURE_GROUP } from './group';

export const ROLES_FEATURES = {
  CREATE: {
    guid: 'b4e91a2c-7d83-4f56-a012-3c8e9f7b0001',
    name: 'roles:create',
    description: 'Create new custom roles for the organization',
    action: 'create',
    product: 'account',
    parentGuid: ROLES_FEATURE_GROUP.guid,
  },
  READ: {
    guid: 'b4e91a2c-7d83-4f56-a012-3c8e9f7b0002',
    name: 'roles:read',
    description: 'View all roles and their permissions',
    action: 'read',
    product: 'account',
    parentGuid: ROLES_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'b4e91a2c-7d83-4f56-a012-3c8e9f7b0003',
    name: 'roles:update',
    description: 'Edit existing custom role configuration',
    action: 'update',
    product: 'account',
    parentGuid: ROLES_FEATURE_GROUP.guid,
  },
  DELETE: {
    guid: 'b4e91a2c-7d83-4f56-a012-3c8e9f7b0004',
    name: 'roles:delete',
    description: 'Delete custom roles from the organization',
    action: 'delete',
    product: 'account',
    parentGuid: ROLES_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ROLES_FEATURE_GROUP } from './group';

export const ROLES_MODULE: FeatureModule = {
  product: 'account',
  groups: [ROLES_FEATURE_GROUP],
  features: featureList(ROLES_FEATURES),
};
